export default {
  contactPage: {
    title: "Contact",
    subtitle: "J'aimerais avoir de vos nouvelles !",
    catchphrase:
      "Que vous ayez une question, une idée de projet ou que vous souhaitiez simplement dire bonjour, n'hésitez pas à m'envoyer un message en utilisant le formulaire ci-dessous. Je suis toujours ravi de rencontrer de nouvelles personnes et d'explorer de potentielles collaborations.",
    successMessage: "Message envoyé avec succès !",
    errorMessage: "Une erreur est survenue lors de l'envoi de votre message.",
    form: {
      emailPlaceholder: "Votre email",
      namePlaceholder: "Votre nom",
      messagePlaceholder: "Votre message",
      sendButton: "Envoyer le message",
      sendingButton: "Envoi...",
      emailError: "Adresse e-mail invalide",
      nameError: "Votre nom est requis",
      messageError: "Le message est requis",
    },
  },
}
